import { useToastStore } from "@/stores/toastStore";
import { CheckCircle, XCircle, AlertTriangle, Info, X } from "lucide-react";

const TYPE_CONFIG = {
  success: {
    classes: "bg-success text-white border-success-600",
    icon: CheckCircle,
  },
  error: {
    classes: "bg-danger text-white border-danger-600",
    icon: XCircle,
  },
  warning: {
    classes: "bg-warning text-white border-warning-600",
    icon: AlertTriangle,
  },
  info: {
    classes: "bg-primary text-white border-primary",
    icon: Info,
  },
};

export function ToastContainer() {
  const { toasts, removeToast } = useToastStore();
  if (toasts.length === 0) return null;

  return (
    <div className="fixed right-4 top-4 z-50 flex flex-col gap-2.5">
      {toasts.map((toast) => {
        const config = TYPE_CONFIG[toast.type];
        const Icon = config.icon;
        return (
          <div
            key={toast.id}
            className={`flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium shadow-lg border ${config.classes} animate-in slide-in-from-right duration-fast`}
          >
            <Icon size={16} strokeWidth={2.5} />
            <span>{toast.message}</span>
            <button
              onClick={() => removeToast(toast.id)}
              className="ml-1 opacity-70 hover:opacity-100 transition-opacity rounded-md p-0.5"
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
